// Helper function to format money using Shopify's format
function formatMoney(cents, format) {
  if (typeof cents === 'string') {
    cents = cents.replace('.', '');
  }
  let value = '';
  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  const formatString = format || '${{amount}}';

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = precision || 2;
    thousands = thousands || ',';
    decimal = decimal || '.';

    if (isNaN(number) || number === null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    const parts = number.split('.');
    const dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
    const centsAmount = parts[1] ? decimal + parts[1] : '';

    return dollarsAmount + centsAmount;
  }

  const match = formatString.match(placeholderRegex);
  if (!match) {
    // If format doesn't match expected pattern, return a simple formatted number
    return formatString.replace(/\d+/, (cents / 100.0).toFixed(2));
  }

  switch (match[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
    case 'amount_with_apostrophe_separator':
      value = formatWithDelimiters(cents, 2, "'", '.');
      break;
    default:
      value = formatWithDelimiters(cents, 2);
  }

  return formatString.replace(placeholderRegex, value);
}

// Add to Cart Modal functionality
//
// DL-2306: dl-add-to-cart.js is loaded inline by `sections/dl-product-slider.liquid`
// and runs synchronously at the point it appears in the page — before sections
// rendered *after* it (like the Repackaged Range slider below Our Newest Launches
// on the homepage) are in the DOM. Querying forms at module-execution time
// missed those later sections, so clicking their CTAs did nothing. We now defer
// the DOM queries and listener bindings until DOMContentLoaded so every
// `[data-product-form]` on the page is picked up regardless of section order.
let modal;
let modalOverlay;
let modalCloseButtons;
let viewCartButton;
let productForms;

// Function to update cart count in navigation
function updateNavigationCart(cartData) {
    // Update cart count in navigation
    const navCartCount = document.querySelector('.dl-navigation-top__cart-count');
    const navCartToggle = document.querySelector('.dl-navigation-top__cart-toggle');

    if (navCartToggle) {
        // Remove existing count badge if present
        const existingBadge = navCartToggle.querySelector('.dl-navigation-top__cart-count');
        if (existingBadge) {
            existingBadge.remove();
        }

        // Add new count badge if cart has items
        if (cartData.item_count > 0) {
            const countBadge = document.createElement('span');
            countBadge.className = 'dl-navigation-top__cart-count';
            countBadge.textContent = cartData.item_count;
            navCartToggle.appendChild(countBadge);
        }
    }

    // Update cart slideover header count
    const slideoverTitle = document.querySelector('.dl-cart-slideover__title');
    if (slideoverTitle) {
        slideoverTitle.textContent = `Shopping Bag (${cartData.item_count})`;
    }
}

// Function to open modal
function openModal(productData, cartData) {
    // Update modal content
    const productInfo = modal.querySelector('[data-atc-product-info]');
    const cartCount = modal.querySelector('[data-cart-count]');
    const cartPlural = modal.querySelector('[data-cart-plural]');
    const cartTotal = modal.querySelector('[data-cart-total]');

    // Format product info
    productInfo.innerHTML = `
        <div class="dl-atc-modal__product-row">
        <img src="${productData.image}" alt="${productData.title}" class="dl-atc-modal__product-image">
        <div class="dl-atc-modal__product-details">
            <h4>${productData.title}</h4>
            <p class="dl-atc-modal__product-price">${productData.price}</p>
        </div>
        </div>
    `;

    // Update cart info
    cartCount.textContent = cartData.item_count;
    cartPlural.style.display = cartData.item_count === 1 ? 'none' : 'inline';

    // Format cart total using Shopify's money format
    const formattedTotal = formatMoney(cartData.total_price, window.shopifyMoneyFormat);
    cartTotal.textContent = formattedTotal;

    // Show modal
    modal.setAttribute('aria-hidden', 'false');
    modal.classList.add('dl-atc-modal--visible');
    document.body.style.overflow = 'hidden';

    // Update navigation cart count
    updateNavigationCart(cartData);

    // Dispatch global cart update event
    window.dispatchEvent(new CustomEvent('cartUpdated', {
        detail: { cart: cartData }
    }));
}

// Function to close modal
function closeModal() {
    modal.setAttribute('aria-hidden', 'true');
    modal.classList.remove('dl-atc-modal--visible');
    document.body.style.overflow = '';
}

function initAddToCart() {
    // Query DOM after the whole page is parsed so forms rendered in sections
    // *after* this script tag (e.g. dl-repackaged-slider) are picked up too.
    modal = document.querySelector('[data-atc-modal]');
    modalOverlay = document.querySelector('.dl-atc-modal__overlay');
    modalCloseButtons = document.querySelectorAll('[data-atc-modal-close]');
    viewCartButton = document.querySelector('[data-view-cart]');
    productForms = document.querySelectorAll('[data-product-form]');

    // Handle form submission with AJAX
    productForms.forEach(form => {
        form.addEventListener('submit', async function(e) {
            e.preventDefault();

            const submitButton = form.querySelector('[data-add-to-cart]');
            const buttonText = submitButton.querySelector('.button__text');
            const buttonSpinner = submitButton.querySelector('.button__spinner');

            // Show loading state

            buttonText.style.display = 'none';
            buttonSpinner.style.display = 'inline-block';
            submitButton.disabled = true;

            // Get product data from form attributes
            const productData = {
            handle: form.dataset.productHandle,
            title: form.dataset.productTitle,
            price: form.dataset.productPrice,
            image: form.dataset.productImage,
            url: form.dataset.productUrl
            };

            try {
                // Submit form data via AJAX
                const formData = new FormData(form);
                const response = await fetch('/cart/add.js', {
                    method: 'POST',
                    body: formData
                });

                if (response.ok) {
                    const addedItem = await response.json();

                    // Fetch updated cart data
                    const cartResponse = await fetch('/cart.js');
                    const cartData = await cartResponse.json();

                    // Open modal with product and cart data
                    openModal(productData, cartData);

                    // Reset button state
                    buttonText.style.display = 'inline';
                    buttonSpinner.style.display = 'none';
                    submitButton.disabled = false;
                } else {
                    throw new Error('Failed to add item to cart');
                }
            } catch (error) {
                console.error('Error adding to cart:', error);

                // Reset button state
                buttonText.style.display = 'inline';
                buttonSpinner.style.display = 'none';
                submitButton.disabled = false;

                // Show error message (you can customize this)
                alert('Sorry, there was an error adding the item to your cart. Please try again.');
            }
        });
    });

    // Close modal event listeners
    modalCloseButtons.forEach(button => {
        button.addEventListener('click', closeModal);
    });

    // Checkout Now button — every Added-to-Bag modal routes straight to checkout
    if (viewCartButton) {
        viewCartButton.addEventListener('click', function() {
            window.location.href = '/checkout';
        });
    }

    // Close modal on Escape key
    document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' && modal && modal.getAttribute('aria-hidden') === 'false') {
            closeModal();
        }
    });
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAddToCart);
} else {
    initAddToCart();
}